export default __webpack_public_path__ + "static/media/windax_1.cd0ecada.jpg";